import markdownit from 'markdown-it'
import  * as AppliedValues from "@/components/explorer/visualizations/AppliedValues.js";
import {ChartTypeEnum, getchartNameFromApiName} from  "@/components/explorer/visualizations/ChartTypeEnum.js"
import { event } from 'vue-gtag'

const version = __APP_VERSION__

const md = markdownit()

class ChartSettings {
    constructor(firstCol, type) {
        //this.seriesDim = secondCol;
 		this.type = type

 		this.currentPage = 0;
		this.pageSize = parseInt(import.meta.env.VITE_API_TABLE_PAGE_SIZE);
		this.totalItems = 0;
		this.totalPages = 1;
		this.sortColumn = firstCol;
		this.sortDirection = firstCol.columnName == 'Year'?'DESC':'ASC';
		this.tableProps = null;
		this.request = null
    }   
}

async function defineExportTableProps(indicatorObj, exportSettings) {

	let indicatorName = indicatorObj.indicatorName
	exportSettings.allDims = getAllDims(indicatorObj)
	exportSettings.valueCol = indicatorObj.valuesLabel; 

	try {
		let infoResult = await fetchTableInfo(indicatorName, exportSettings.allDims)
		//console.log('Tbl infoResult', infoResult);
		exportSettings.totalItems = infoResult.count;
		exportSettings.totalPages = Math.ceil(exportSettings.totalItems / exportSettings.exportPageSize)

		const request = buildInitDataRequest("export", indicatorObj, exportSettings, exportSettings.allDims)
		exportSettings.request = request
		//console.log('tbl exportSettings', exportSettings)			
		return
	} catch (err) {
		console.log('Error in defineExportTableProps', err)
		throw err
	}
}

async function defineTableProps(indicatorObj, chartSettings, userInputStatus) {

	let indicatorName = indicatorObj.indicatorName
	let allDims = getAllDims(indicatorObj)

	allDims.forEach(d => {
		let found = d.appliedValues.find(x => x.selected)
		if(!userInputStatus.year && found && d.columnName == 'Year') {			
			d.appliedValues.forEach(x => x.selected = true)
		}
		if(!found)
			throw new Error("No records found");
	})
	
	try {
		let infoResult = await fetchTableInfo(indicatorName, allDims)
		//console.log('Tbl infoResult', infoResult);
		if(infoResult.count == 0) {
			throw new Error("No records found");
		}
		chartSettings.totalItems = infoResult.count;
		chartSettings.totalPages = Math.ceil(chartSettings.totalItems / chartSettings.pageSize)

		const request = buildInitDataRequest("table", indicatorObj, chartSettings, allDims)
		chartSettings.request = request
		if(import.meta.env.VITE_APP_DEBUG)
			console.log('tbl chartSettings', chartSettings)			

		let result = await fetchInitialData(request)
		if(import.meta.env.VITE_APP_DEBUG)
			console.log('Tbl data Result', result);

		buildTableJson(indicatorObj, chartSettings, allDims, result)
		return
	} catch (err) {
		console.log('Error in defineTableProps', err)
		throw err
	}
}

async function pageTableProps(indicatorObj, chartSettings) {
	let allDims = getAllDims(indicatorObj)

	chartSettings.request = buildInitDataRequest("table", indicatorObj, chartSettings, allDims)

	try {
		let result = await fetchPageData(chartSettings)
		if(import.meta.env.VITE_APP_DEBUG)
			console.log('Tbl data Result', result);
		return buildTableJson(indicatorObj, chartSettings, allDims, result)
	} catch (err) {
		console.log('Error in defineTableProps', err)
		throw err
	}
}

async function fetchTableInfo(indicatorName, allFilters) {
	//console.log(indicatorName)
	const apiUrl = import.meta.env.VITE_API_URL;

	let request = {
		"datasetName": indicatorName,
		"columns": []
	}

 	allFilters.forEach(col => {
		let cat = {}
		cat.columnName = col.columnName
		
 		let selectedVals = []
		col.appliedValues.forEach(s => {
			if(s.selected) {   // && s.visible
				selectedVals.push(s.name)
			}
		})

		cat.filters = selectedVals
		request.columns.push(cat)	
	})

	let reqFilters = '';
	request.columns.forEach((cat) => {
		reqFilters += cat.columnName + ': ' + cat.filters.join() + '|';
	})
	event('filter_dataset', { 'indicator' : request.datasetName, 'dimensions': null, 'filter' : reqFilters.slice(0,100).slice(0,-1) })

	//console.log('request tbl info', request)
	let url = apiUrl + '/indicators/api/tableinfo'
	let response = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'x-api-version': version
		},
			body: JSON.stringify(request)
		}
	)
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return await response.json()
}

function buildInitDataRequest(type, indicator, chartSettings, allFilters) {
	let request = {
		"datasetName": indicator.indicatorName,
		"page": chartSettings.currentPage,
		"pageSize": type == "export"?chartSettings.exportPageSize:chartSettings.pageSize,
		"columns": []
	}
	//let sortOrder = 1
 	allFilters.forEach(col => {
		let cat = {}
		cat.columnName = col.columnName
		if(col.columnName == chartSettings.sortColumn.columnName) {
			cat.sortOrder = 0;
			cat.sortDir = chartSettings.sortDirection
		} else {
			cat.sortOrder = 1; //sortOrder++;
			if(chartSettings.request && chartSettings.request.columns) {
				let found = chartSettings.request.columns.find(x => x.columnName == cat.columnName)
				cat.sortDir = found && found.sortDir||"ASC"
			} else {
				cat.sortDir = "ASC"
			}
		}
		
		let selectedVals = []
		col.appliedValues.forEach(s => {
			if(s.selected) {   // && s.visible
				selectedVals.push(s.name)
			}
		})
		cat.filters = selectedVals
		request.columns.push(cat)
	})
	if(indicator.valuesLabel == chartSettings.sortColumn.columnName) {
		let cat = {}
		cat.columnName = indicator.valuesLabel
		cat.sortOrder = 0;
		cat.sortDir = chartSettings.sortDirection
		request.columns.push(cat)	
	}
	return request;
}
async function fetchInitialData(request) {
	//console.log(indicatorName)
	const apiUrl = import.meta.env.VITE_API_URL;

	request.columns.forEach((col) => {
		event('filter_dataset', { 'indicator' : request.datasetName, 'filter' : col.columnName })
	})

	let url = apiUrl + '/indicators/api/tabledata'
	let response = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'x-api-version': version
		},
			body: JSON.stringify(request)
		}
	)
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return await response.json()
}

async function fetchPageData(chartSettings) {
	const apiUrl = import.meta.env.VITE_API_URL;

	let request = chartSettings.request
	request.page = chartSettings.currentPage
	//console.log('request tbl', request)

	let url = apiUrl + '/indicators/api/tabledata'
	let response = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'x-api-version': version
		},
			body: JSON.stringify(request)
		}
	)
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return await response.json()
}

function convertColumnMapToRows(dataObj, valueCol, allDims) {
	const cols = [];
	//Add category columns in order of response but place value column last
	for(let x=0; x < allDims.length; x++) {
		const tmpKey = allDims[x].columnName
		if(valueCol && tmpKey == valueCol)
			continue	
		cols.push(tmpKey)
	}
 	if(valueCol != null){
		const tmpArr = dataObj[valueCol]
		if(tmpArr != null) {
			cols.push(valueCol)
		}
	}	

	//If notes column exist append as last row
 	const tmpArr = dataObj['Notes']
	if(tmpArr != null) {
		cols.push("Notes")
	}

	//Build columns map object with column name as key and data array as values
	let columns = {}
	cols.forEach(c => {
		let d = c.replace(/[',!]/g, "");
		columns[c] = Object.values(dataObj[d])
		//columns[c] = dataObj[c]
	})	
	return columns;
}

const buildTableJson = (indicator, chartSettings, allDims, result) => {

	const valuesUnit = indicator.valuesUnit	
	//const valuesRoundingUnit = (indicator.roundingUnit && indicator.roundingUnit.length > 0 ? '(' + indicator.roundingUnit.replace(/[$%]/g, "") + ')' : null
	const valuesRoundingUnit = (indicator.roundingUnit && indicator.roundingUnit.length > 0 ? '(' + indicator.roundingUnit + ')' : null);
	//const usdFormatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2});
	const pctFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: indicator.decimalPrecision, maximumFractionDigits: 2});
	const floatFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: indicator.decimalPrecision, maximumFractionDigits: 100});
	const numFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 100})

	let formatter = valuesUnit == "Currency"?numFormatter:valuesUnit == "Percent"?pctFormatter:valuesUnit=="Float"?floatFormatter:numFormatter
	
	let valueCol = indicator.valuesLabel;
	let dataObj
	try {
		dataObj = convertColumnMapToRows(result, valueCol, allDims);
	} catch (err) {
		console.log(err.message)
		throw err
	}

	//Remove parent from table if it exists in returned data
/* 	let parentCol = allDims.find(p => p.childColumnName != null)
	let dataProp
	if(parentCol != null) {
		for(let c in dataObj) {
			if(c == parentCol.columnName)
				dataProp = c
		}
	}
	if(dataProp)
		delete dataObj[dataProp] 
*/

	let columnDefs  = []
	for(let c in dataObj) {
		if(c == 'Year') {
			columnDefs.push({
				id: c,
				header: {
 					formatter() {
						return `
							<div class="table-header-col">
								<span title="${c}">${c}</span>
								<button class="btn-header-arrows" aria-label="Sort" onclick="clickHandler(e)">
									<span class="arrow-icon"</span>
								</button>
							</div>
						`
					},										
				},
				className: 'hc-grid-left',					
				cells: {
					formatter() {
						return String(this.value);   // prevents comma formatting
					},					
					//align: "left"
					className: 'hc-grid-left'   // Custom class for left-align				
				}				
			});
		}else if(c == valueCol) {
			columnDefs.push({
				id: c,
			    header: {	
					formatter: () => {
						//let valHdr = indicator.roundingUnit && indicator.roundingUnit != ""?`<span title="${c}">${c} <br> (${indicator.roundingUnit})</span>`:`<span title="${c}">${c}</span>`
						//let subHeader =  indicator.valuesUnit && indicator.valuesUnit !== "" ? `${indicator.valuesUnit}` : ''
						//const subHeader = (valuesRoundingUnit && valuesRoundingUnit.length > 0 ? '(' + valuesRoundingUnit + ')' : null);				
						// if(subHeader != null) {
						// 	subHeader += indicator.roundingUnit !== "Number" ? ` ${indicator.roundingUnit}` : ''
						// }

						let valHdr = valuesRoundingUnit && valuesRoundingUnit != ""?`<span title="${c}">${c} <br>${valuesRoundingUnit.trim()}</span>`:`<span title="${c}">${c}</span>`
						//let valHdr = `<span title="${c}">${c}</span>`
						return `<div class="table-header-col">
								${valHdr}
								<button class="btn-header-arrows"  aria-label="Sort" onclick="clickHandler(e)">
									<span class="arrow-icon"</span>
								</button>
							</div>`
					},						
				},
				className: 'hc-grid-left',					
				cells: {
					formatter() {
						// if(this.value == '' || isNaN(this.value))
						// 	return this.value
						// else if(indicator.valuesUnit == "Currency")
						// 	//return usdFormatter.format(this.value);  
						// 	return numFormatter.format(this.value); 
						// else if(indicator.valuesUnit == "Number")
						// 	return numFormatter.format(this.value); 
						// else if(indicator.valuesUnit == "Percent")
						// 	return pctFormatter.format(this.value);
						// //TODO: Enable new formatter logic if Float valuesUnit implemented
						// else if(indicator.valuesUnit == "Float")
						//  	return floatFormatter.format(this.value);																 							
						// else if(typeof this.value === "number")
						// 	return numFormatter.format(this.value); 
						// else
						// 	return String(this.value);   // prevents comma formatting
						if(this.value == 0) {
							return this.value
						} else {
							//return formatter.format(this.value) //_Highcharts.numberFormat(this.value, 0)
							//accomodates values in string format like:  "60,000"
							if(typeof this.value === 'string') {
								let val, str = this.value.replaceAll(",", "")
								if(str == ''||isNaN(str)) {
									val = null
								} else {
									val = parseFloat(str)
								}
								return formatter.format(val)
							} else {
								return formatter.format(this.value)
							}
						}						
					},
					//align: "left"
					className: 'hc-grid-left'   // Custom class for left-align				
				}				
			});
		} else if(c !== 'Notes') {
			columnDefs.push({
				id: c,
				header: {
					formatter: () => `
						<div class="table-header-col">
							<span title="${c}">${c}</span>
							<button class="btn-header-arrows"  aria-label="Sort" onclick="clickHandler(e)">
								<span class="arrow-icon"</span>
							</button>
						</div>`
				},									
				className: 'hc-grid-left', //header									
				cells: {
					formatter() {
						return String(this.value);   // prevents comma formatting
					},
					//align: "left"
					className: 'hc-grid-left'   // Custom class for left-align				
				}				
			});
		} else if(c == 'Notes') {
			columnDefs.push({
				id: c,
				header: {
					//format: c
					format: `<span title="${c}">${c}</span>`
				},
				width: 110,
				className: 'hc-grid-left', //header
				//sortable: false,
				sorting: {
					enabled: false,       // Keeps the sorting UI (arrows) visible
					orderSequence: []    // Disables the click-to-toggle behavior on the header
				},								
				cells: {
					className: 'hc-grid-left'   // Custom class for left-align
				}				
			})
		} 
	}

	let tblProps = {	
		lang: {
			locale: 'en-US' 
		},				
 		dataTable: {
			columns: dataObj,
		// 	credits: {
		// 		enabled: false
		// 	}					
		},
		columns: columnDefs ,
		rendering: {
			theme: 'hcg-theme-default theme-compact',
			rows: {
				strictHeights: true
			},
			credits: {
				enabled: false
			},					
		},	
/* 		caption: {
			text: indicator.indicatorName,
			className: 'tbl-header'
		}, */
		description: {
			text: result.source,
			className: 'table-footnote'
		}, 
		credits: {
			enabled: false
		},
		columnDefaults: {
			sorting: {
				enabled: false,        // keep arrows visible
				orderSequence: []     // disables ALL built-in sorting
			},								
		}
	}
	//tblProps.title = indicator.indicatorName;
	tblProps.title = valueCol;
	// if(valuesRoundingUnit) {
	// 	tblProps.title += ' ' + valuesRoundingUnit;
	// }

	chartSettings.tableProps = tblProps
	return;
}

function getAllDims(indicator) {
	let columns = indicator.columns.items.filter(col => {
		if(col.categoryLabelFlag)
			return col;
	})
	return columns
}

function getTableSettings(indicator, type, userInputStatus) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('getTableSettings')
	}
	AppliedValues.setupAppliedValues(indicator)
	//default selected category to first valid category, select all values including totals
	let firstCol = indicator.columns.items.find(col => col.categoryLabelFlag)
	return new ChartSettings(firstCol, type)
}

function updateTableSettings(settings, indicator, type, userInputStatus) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('updateTableSettings')
	}

	let firstCol = indicator.columns.items.find(col => col.categoryLabelFlag);

	settings.type = type
	settings.currentPage = 0;
	settings.pageSize = parseInt(import.meta.env.VITE_API_TABLE_PAGE_SIZE);
	settings.exportPageSize = parseInt(import.meta.env.VITE_API_EXPORT_PAGE_SIZE);
	settings.totalItems = 0;
	settings.totalPages = 1;	
	settings.sortColumn = firstCol
	settings.sortDirection = firstCol.columnName == 'Year'?'DESC':'ASC';
	settings.tableProps = null;

	//If seriesDim is a geography column use defaultValues if user has not input
	if(settings.seriesDim && settings.seriesDim.geoLabelFlag && !userInputStatus.geo) {
		const defaultValuesTrimmed = settings.seriesDim.defaultValues.map(item => 
			typeof item === 'string' ? item.trim() : item
		);
		if(defaultValuesTrimmed.length){
			settings.seriesDim.appliedValues.forEach(x => {
				if(defaultValuesTrimmed.includes(x.name)){
					x.selected = true
				}else {
					x.selected = false
				}
			})
		}
	}

	return settings
}

//Method called when table is being rebuilt from URL parameters
function rebuildTableSettings(indicator, type, objReq) {

	AppliedValues.setupAppliedValues(indicator)
	AppliedValues.applyRequestFilters(indicator, type, objReq.request)
	let firstCol = indicator.columns.items.find(col => col.categoryLabelFlag)
	return new ChartSettings(firstCol, type)
}
 	
function validateRequestProps(obj, indicator) {
	return AppliedValues.validateRequestValues(obj, indicator, ChartTypeEnum.TABLE.chartName)
}
export {defineTableProps, getTableSettings, updateTableSettings, rebuildTableSettings, validateRequestProps, pageTableProps, defineExportTableProps, fetchPageData}
